import { SystemBase } from '@inter-ikea-core/core-toolbox';
import { ComponentIds, ConnectionUtils, HierarchyUtils, RelativeConnectorRepositioner, SnapRootComponent, TransformUtils } from '@inter-ikea-core/core';
import RequireSizeAdjustmentComponent from '../components/RequireSizeAdjustmentComponent';
import AdjustableStateComponent from '../components/AdjustableStateComponent';
import { CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY } from '../types';
export const MOVEABLE = 'moveable';
export const STATIC = 'static';
export const CONNECTOR_DOESNT_EXISTS = 'Connector doesnt exist';
export const COMPONENT_DOESNT_EXIST = "Component doesn't exist.";
/**
 * Copeid from S2 until we have moved over their code to this repo.
 * System that handles the adjustment of the size of a moveable part.
 */
export class AdaptAdjustableSystem extends SystemBase {
    constructor(coreApi) {
        super(RequireSizeAdjustmentComponent.id);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = 'AdaptAdjustableSystem';
        this.adjustSize = (entity, guestConnectorKey, host, hostConnector) => {
            const moveablePart = this.getAdjustableMoveablePart(entity);
            const guestConnector = this.getConnectorsComponent(moveablePart).getConnectorByKey(guestConnectorKey);
            if (!guestConnector)
                throw new Error('No guest connector found on entity.');
            moveablePart.addComponent(new SnapRootComponent());
            const guestConnectorWorldSpacePosition = guestConnector.getWorldPositionFromOwnerEntity(moveablePart);
            const hostConnectorWorldSpacePosition = hostConnector.getWorldPositionFromOwnerEntity(host);
            const deltaWorldSpace = hostConnectorWorldSpacePosition.minus(guestConnectorWorldSpacePosition);
            const deltaMovablePartSpace = TransformUtils.worldTransform(moveablePart)
                .inverse()
                .transformVector(deltaWorldSpace);
            TransformUtils.moveInLocalSpace(moveablePart, deltaMovablePartSpace);
            ConnectionUtils.refreshConnections(moveablePart, host);
            this.coreApi
                .getSystem('AlignmentConnectionCreationSystem')
                ?.refreshAlignments([host, moveablePart]);
            return {
                rollbackSize: () => {
                    TransformUtils.moveInLocalSpace(moveablePart, deltaMovablePartSpace.times(-1));
                    RelativeConnectorRepositioner.repositionRelativeConnectorsFromBounds(entity);
                }
            };
        };
        this.getAdjustableMoveablePart = (entity) => {
            const moveablePart = HierarchyUtils.children(entity).find(child => {
                const adjustableState = this.getAdjustableStateComponent(child, true)?.state;
                return adjustableState === MOVEABLE;
            });
            if (!moveablePart)
                throw new Error('Entity lacking the necessary characteristics of an adjustable assembly');
            return moveablePart;
        };
        this.getAdjustableStateComponent = (entity, allowFail = false) => {
            const adjustableStateComponent = entity.getComponent(AdjustableStateComponent.id);
            if (!adjustableStateComponent && !allowFail)
                throw new Error(COMPONENT_DOESNT_EXIST);
            return adjustableStateComponent;
        };
        this.getConnectorsComponent = (entity) => {
            const connectors = entity.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
            if (!connectors)
                throw new Error(CONNECTOR_DOESNT_EXISTS);
            return connectors;
        };
        this.coreApi = coreApi;
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const { host, hostConnector } = _newComponent;
        this.adjustSize(_entity, CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY, host, hostConnector);
        _entity.removeComponent(RequireSizeAdjustmentComponent.id);
    }
}
//# sourceMappingURL=AdaptAdjustableSystem.js.map